"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.config = void 0;

/**
 * @private
*/
var config = {
  data: {
    request: {
      endpoint: 'fires'
    },
    properties: {
      id: 'report.id',
      timestamp: 'report.timestamp'
    }
  },
  style: {
    marker: function (data) {
      var width = 12;
      return {
        className: 'marker-earthquake',
        svg: {
          shape: {
            type: 'circle',
            fill: {
              color: '#ff0000'
            },
            stroke: {
              color: '#ffffff',
              width: 2
            }
          }
        },
        size: [width, width]
      };
    }
  },
  animation: {
    enabled: true
  }
};
exports.config = config;
var _default = config;
exports.default = _default;